import { CapitalizeFirstLetterUtil } from './capitalizeFirstLetter.types';

export const capitalizeFirstLetter: CapitalizeFirstLetterUtil = (str) => {
  return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
};
